import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 bg-bbap-bg">
      <h1 className="font-display font-black text-6xl text-zinc-950 mb-4">404</h1>
      <p className="text-zinc-500 mb-8">This page doesn't exist.</p>
      <Link to="/"><Button className="bg-zinc-950 text-white rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">Back to Home</Button></Link>
    </div>
  );
}
